module.exports = __webpack_public_path__ + "static/assets/cffd696507333416114150fd79fe0ee3.png";